import { useContext } from "react";
import debugContext from "@lib/contexts/debug";
import DebugInfo from "@components/Debug/Info";

export default function DebugLocationPopup({
  className = "",
  label,
  location,
}: {
  className?: string;
  label: string;
  location?: be.Location;
}) {
  const { debugMode } = useContext(debugContext);

  if (!debugMode || !location) return null;

  return (
    <DebugInfo
      className={className}
      dialogContent={
        <>
          {location.raw && (
            <>
              <div className="font-bold text-lg">Location JSON (from FKL)</div>
              <pre>{JSON.stringify(JSON.parse(location.raw), null, 2)}</pre>
            </>
          )}

          {!location.raw && (
            <>
              <div className="font-bold text-lg">Internal Location Data Structure</div>
              <pre>
                {JSON.stringify(
                  location,
                  [
                    "key",
                    "addressDetails",
                    "type",
                    "title",
                    "description",
                    "id",
                    "code",
                    "address",
                    "city",
                    "country",
                    "county",
                    "crossStreet",
                    "directions",
                    "displayAddress",
                    "displayName",
                    "googlePlaceId",
                    "latLng",
                    "name",
                    "requireCrossStreet",
                    "sector",
                    "serviceArea",
                    "showAddressDetails",
                    "showCrossStreet",
                    "showFlightDate",
                    "showFlightNumber",
                    "showFlightType",
                    "state",
                    "telephone",
                    "transportationHub",
                    "typeString",
                    "zip",
                  ],
                  2,
                )}
              </pre>{" "}
            </>
          )}

          {location.fklRequest && (
            <>
              <div className="font-bold text-lg mt-3">fareKeyLookup Request</div>
              <pre>{JSON.stringify(JSON.parse(location.fklRequest), null, 2)}</pre>
            </>
          )}

          {location.fklResponse && (
            <>
              <div className="font-bold text-lg mt-3">fareKeyLookup Response</div>
              <pre>{JSON.stringify(JSON.parse(location.fklResponse), null, 2)}</pre>
            </>
          )}
        </>
      }
    >
      {label}
    </DebugInfo>
  );
}
